import {combineReducers} from "redux"
import Modal from "./Modal"

const App = combineReducers({
  Modal
})

export default App


// WEBPACK FOOTER //
// ./src/reducers/RootReducer.js